import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guide-o365-enterprise-application',
  templateUrl: './guide-o365-enterprise-application.component.html',
  styleUrls: ['./guide-o365-enterprise-application.component.scss']
})
export class GuideO365EnterpriseApplicationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
